import axios from 'axios'
import Qs from '@/utils/qs'
import {filterPath, filterIsBlob} from './filterPath'
import {Message} from 'element-ui'
import store from '@/store'
// import {getToken} from '@/utils/auth'
import {isEmptyObject} from '@/utils/index'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: SERVERCONFIG.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000, // request timeout
  // 默认设置请求头 FormData 数据格式
  headers: {'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'},
  // 默认设置'post'请求
  method: 'post'
})

// request interceptor
service.interceptors.request.use(
  config => {
    // console.log(config, '!!!!!!!!!!!!!!!!!!')
    // 过滤请求地址是否为开发、测试、正式环境
    const BASE_PATH = filterPath(config.type)
    // 过滤请求返回文件类型是否为blob
    config.responseType = filterIsBlob(config.url) ? 'blob' : config.responseType
    // 判断是否为get请求，如果是传参方式修改
    if (config.method === 'get') config.params = config.data
    // 是否为地图调用方式（企盟家原来swagger类型）
    if (config.type === 'map') {
      // config.baseURL = SERVERCONFIG.VUE_APP_MAP_API + BASE_PATH
      // config.headers = {'Accept': '*/*'}
    } else {
      config.baseURL += BASE_PATH
      // console.log(config, '@@##############')
      // 把JSON 转换为 FormData 格式
      if (config.type === 'point') {
        config.headers = {'content-type': 'application/json;charset=UTF-8'}
      } else {
        config.data = Qs.stringify(config.data)
      }
      // do something before request is sent
      if (store.getters.token) {
        // let each request carry token
        // ['Authorization'] is a custom headers key
        // please modify it according to the actual situation
        config.headers['Authorization'] = 'Bearer ' + store.getters.token
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (!isEmptyObject(res)) {
      if (/ERR_/.test(res)) {
        const errorJson = JSON.parse(res.replace('ERR_{', '{'))
        /*Message({
          message: errorJson.msg || 'Error',
          type: 'error',
          duration: 3 * 1000
        })*/
        console.log('requesr fial:', errorJson.msg || 'Error')
        return Promise.reject(errorJson)
      } else if (res == null || res === '') {
        Message({
          message: '请求无响应',
          type: 'error',
          duration: 3 * 1000
        })
        return Promise.reject(new Error({code: '4040', msg: '请求无响应'}))
      } else {
        // 正常响应处理
        return (res)
      }
    } else {
      return (res)
    }
  },
  error => {
    console.log(error, 'dddddd')
    const data = error.response.data
    console.log('3001:', data, error)
    if (!isEmptyObject(data)) {
      if (/ERR_/.test(data)) {
        const errorJson = JSON.parse(data.replace('ERR_{', '{'))
        /*Message({
          message: errorJson.msg || 'Error',
          type: 'error',
          duration: 3 * 1000
        })*/
        console.log('requesr fial:', errorJson.msg || 'Error')
        if (errorJson.code === '3001') {
          store.dispatch('user/logout')
          router.push(`/login`)
        }
        return Promise.reject(errorJson)
      }

      if (data.error_description) {
        switch (data.error_description) {
          case 'Bad client credentials':
            data.error_description = '客户端认证失败'
            break
          case 'User is disabled':
            data.error_description = '用户不存在'
            break
          case 'UserDetailsService returned null, which is an interface contract violation':
          case 'Bad credentials':
            data.error_description = '账号或密码错误'
            break
          case 'User account is locked':
            data.error_description = '用户已被禁用，请联系管理员'
            break
          default:
            data.error_description = '认证失败'
        }
        Message({
          message: data.error_description,
          type: 'error',
          duration: 3 * 1000
        })
      } else {
        Message({
          message: error.message,
          type: 'error',
          duration: 3 * 1000
        })
        console.log('requesr fial:', error.message)
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js